import React from "react";
import ListedCoinInfoCard from "../../components/CoinInfoComponents/ListedCoinInfoCard";

const ListedCoinInfo = ({ coinZMT, listedCoins, newListedCoins }) => {
  return (
    <>
      <ListedCoinInfoCard
        classNames="col-md-6 col-lg-4"
        linkTo="/zmt/"
        featuredImageSharp={coinZMT}
        tickerSymbol="ZMT"
        fullName="Zipmex Token"
      />
      {listedCoins.nodes.map(({ slug, acfCoinInfo }, i) => (
        <ListedCoinInfoCard
          key={`coin-card-item-${i}`}
          classNames="col-md-6 col-lg-4"
          linkTo={`/coin-info/${slug}/`}
          featuredImageSharp={acfCoinInfo.ciHomeImage.localFile}
          tickerSymbol={acfCoinInfo.ciHomeShortName}
          fullName={acfCoinInfo.ciHomeFullName}
        />
      ))}
      {newListedCoins.nodes.map(({ slug, acfCoinInfo }, i) => (
        <ListedCoinInfoCard
          key={`new-coin-card-item-${i}`}
          classNames="col-md-6 col-lg-4"
          linkTo={`/coin-info/${slug}/`}
          featuredImageSharp={acfCoinInfo.ciHomeFeaturedImage.localFile}
          fullName={acfCoinInfo.ciHomeFullName}
          tickerSymbol={acfCoinInfo.ciTickerSymbol}
        />
      ))}
    </>
  );
};

export default ListedCoinInfo;
